import StandSelect from './stand-select-form-item';

export default StandSelect;